import { render, staticRenderFns } from "./TabsMenu.vue?vue&type=template&id=5d7c41ae&scoped=true"
import script from "./TabsMenu.vue?vue&type=script&lang=js"
export * from "./TabsMenu.vue?vue&type=script&lang=js"
import style0 from "./TabsMenu.vue?vue&type=style&index=0&id=5d7c41ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7c41ae",
  null
  
)

export default component.exports